import { createSlice } from "@reduxjs/toolkit"
import {
  addCountry,
  deleteCountry,
  getAllCountries,
  getAllCountryList,
  getCountryDetails,
  getCountryList,
  updateCountry,
  updateCountryStatus,
} from "store/actions/countriesAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  isCountryDropdownLoading: null,
  countries: [],
  countryList: [],
  countryDetails: {},
}

const usersSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL COUNTRIES
    builder
      .addCase(getAllCountries.pending, state => {
        state.loading = true
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.countries = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCountries.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL COUNTRIES LIST
    builder
      .addCase(getCountryList.pending, state => {
        state.loading = true
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.countryList = data
        }
      })
      .addCase(getCountryList.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE COUNTRY STATUS
    builder
      .addCase(updateCountryStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isLoading = true
      })
      .addCase(updateCountryStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.countries = state.countries.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateCountryStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD COUNTRY
    builder
      .addCase(addCountry.pending, state => {
        state.isLoading = true
      })
      .addCase(addCountry.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addCountry.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET COUNTRY DETAILS
    builder
      .addCase(getCountryDetails.pending, state => {
        state.loading = true
        state.countryDetails = {}
      })
      .addCase(getCountryDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.countryDetails = data
        }
      })
      .addCase(getCountryDetails.rejected, (state, action) => {
        state.loading = false
      })

    //  UPDATE COUNTRY
    builder
      .addCase(updateCountry.pending, state => {
        state.isLoading = true
        state.countryDetails = {}
      })
      .addCase(updateCountry.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCountry.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE COUNTRY
    builder
      .addCase(deleteCountry.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteCountry.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.countries = state.countries.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteCountry.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
